import type { AuthSession, UserRole } from '../types/domain';

const SESSION_KEY = 'lms_auth_session';

export function getSession(): AuthSession | null {
  const raw = localStorage.getItem(SESSION_KEY);
  if (!raw) return null;

  try {
    const parsed = JSON.parse(raw) as AuthSession;
    if (!parsed.role || !parsed.name) {
      localStorage.removeItem(SESSION_KEY);
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
}

export function setSession(
  role: UserRole,
  name: string,
  loginId?: string,
  userId?: string,
  tenantId?: string,
  tenantSlug?: string,
) {
  const session: AuthSession = { role, name, loginId, userId, tenantId, tenantSlug };
  localStorage.setItem(SESSION_KEY, JSON.stringify(session));
}

export function clearSession() {
  localStorage.removeItem(SESSION_KEY);
}
